import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
// 无公共 Footer，仅保留自定义页面内容
import defaultSettings from '../config/defaultSettings';
import '@ant-design/v5-patch-for-react-19';

const _isDev = process.env.NODE_ENV === 'development';

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 *
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
}> {
  return {
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState }) => ({
  layout: 'top',
  menuRender: false,
  contentStyle: {
    padding: '0 24px',
  },
  actionsRender: () => [],
  footerRender: false,
  onPageChange: () => {
    // const { location } = history;
  },
  // 自定义头部，嵌入站点级导航
  headerRender: () => {
    const SiteHeader = require('@/components/SiteHeader').default;
    return <SiteHeader />;
  },
  menuHeaderRender: false,
  bgLayoutImgList: [],
  links: [],
  // 为所有页面提供统一的左右留白
  childrenRender: (children) => (
    <div style={{ padding: '16px 0' }}>{children}</div>
  ),
  ...initialState?.settings,
});

import { ThemeProvider } from '@/theme/Provider';
import {
  initPerformanceOptimizations,
  monitorCoreWebVitals,
} from '@/utils/performance';
export function rootContainer(container: React.ReactNode) {
  // 初始化性能优化
  if (typeof window !== 'undefined') {
    initPerformanceOptimizations();
    monitorCoreWebVitals();
  }
  return (
    <HelmetProvider>
      <ThemeProvider>{container}</ThemeProvider>
    </HelmetProvider>
  );
}
